import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { StepNavigatorComponent } from './step-navigator/step-navigator.component';
import { FormsModule } from '@angular/forms';
import { HostDirective } from './directive/host.directive';
import { HighlightDirective } from './directive/highlight.directive';

@NgModule({
    declarations: [HostDirective, StepNavigatorComponent, HighlightDirective],
    imports: [CommonModule, FormsModule, MatButtonToggleModule],
    exports: [HostDirective, HighlightDirective, StepNavigatorComponent],
})
export class CSBCoreModule {}
